import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import equal from "fast-deep-equal";

import * as homeReducer from "containers/Home/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as globalReducer from "containers/App/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as viewReducer from "containers/View/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import NextReport from "components/Next/NextReport";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class NextReportContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    const isEqual = equal(this.props, nextProps);

    return isEqual === true ? false : true;
  }

  render() {
    return <NextReport {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const datasetId = ownProps?.datasetId;

  return {
    updateSelectedHex: (hex) => dispatch(nextReducer.updateSelectedHex(id, hex, undefined, true)),
    updateSelectedTransformHex: (hex, node) => dispatch(nextTransformReducer.handleUpdate(id, hex, node)),
    updateSelectedChart: (hex, node) => dispatch(nextReducer.updateSelectedChart(id, hex, node)),
    updateHover: (node) => dispatch(nextReducer.updateHover(id, node)),
    updatePinnedHex: (hex, node) => dispatch(nextReducer.updatePinnedHex(id, hex, node)),
    removePin: (hex, node) => dispatch(nextReducer.removePin(id, hex, node)),
    removeNode: (hex, node) => dispatch(nextReducer.removeNode(id, hex, node)),
    removeAllNodes: (node) => dispatch(nextReducer.removeAllNodes(id, node)),

    handleChartLink: (node) => dispatch(nextReducer.handleChartLink(id, node)),

    updateIsLeftClosed: (isLeftClosed) => dispatch(nextReducer.updateIsLeftClosed(id, isLeftClosed)),

    replayActions: (stopNode) => dispatch(nextReducer.replayActions(id, stopNode)),
    assignTodo: (todo) => dispatch(nextModelsReducer.assignTodo(id, todo)),
    updateIsCommentModal: (isCommentModal) => dispatch(nextModelsReducer.updateIsCommentModal(id, isCommentModal)),

    updateIsReportExpand: (isReportExpand, node) =>
      dispatch(nextReducer.updateIsReportExpand(id, isReportExpand, node)),
    updateDatasetSuccess: (success) => dispatch(nextReducer.updateDatasetSuccess(id, success)),
    updateDrilldownValue: (projectId, runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(projectId, runId, drilldownValue)),

    copyAndChangeDatasetSuccess: (datasetId, success) =>
      dispatch(homeReducer.copyAndChangeDatasetSuccess(datasetId, success)),
    updateViewType: (type) => dispatch(viewReducer.updateType(type)),
    updateComparisonOptions: (comparisonOption) => dispatch(nextReducer.updateComparisonOptions(id, comparisonOption)),
    openExploration: (datasetId, outcomeValue, comparisonOptions) =>
      dispatch(nextReducer.openExploration(datasetId, outcomeValue, comparisonOptions)),
    createExploration: (comparisonOptions) =>
      dispatch(nextTransformReducer.createDefaultExplore(id, comparisonOptions, undefined, 0, false, true)),
    updateIsHeatmapGlobalScale: (isHeatmapGlobalScale) => {
      dispatch(nextReducer.updateIsHeatmapGlobalScale(id, isHeatmapGlobalScale));
    },
    updateContinuousGraphDisplayType: (type) => dispatch(nextReducer.updateContinuousGraphDisplayType(id, type))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = nextReducer.getDatasetId(state, id);
  const projectId = nextReducer.getProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  return {
    id: id,
    datasetId: datasetId,
    projectId: projectId,
    runId: runId,

    dataset: homeReducer.getDataset(state, datasetId),
    successValue: setupReducer.getSuccess(state, runId),

    interactionsEvaluated: nextReducer.getInsightCombinationCount(state, id),

    charts: nextReducer.getPinnedHexList(state, id),

    bestCharts: nextReducer.getBestCharts(state, id),

    selectedHex: nextReducer.getSelectedHex(state, id),
    selectedChart: nextReducer.getSelectedChart(state, id),

    gridType: nextReducer.getGridType(state, id),
    reportLabel: nextReducer.getReportLabel(state, id),
    isReportExpand: nextReducer.getIsReportExpand(state, id),
    chartsCount: nextReducer.getChartsCount(state, id),

    selectedTransformNode: nextTransformReducer.getSelectedNode(state, id),
    selectedTransformHex: nextTransformReducer.getSelectedHex(state, id),

    datasetSuccess: nextReducer.getDatasetSuccess(state, id),
    successOptions: homeReducer.getSuccessOptions(state, datasetId),
    datasetTargetValue: homeReducer.getTargetValue(state, datasetId),
    outcomeType: homeReducer.getOutcomeType(state, datasetId),

    project: projectReducer.getProject(state, projectId),

    isOutcomeMulticategorical: homeReducer.getIsOutcomeMulticategorical(state, datasetId),
    defaultSuccess: homeReducer.getDefaultSuccess(state, datasetId),

    comparisonOptions: nextReducer.getComparisonOptions(state, id),
    isHeatmapGlobalScale: nextReducer.getIsHeatmapGlobalScale(state, id),
    continuousGraphDisplayType: nextReducer.getContinuousGraphDisplayType(state, id),
    scrollReportTitle: nextReducer.getScrollReportTitle(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(NextReportContainer);
